<template>
  <div
    v-if="canRequest"
    class="ltcs-missing-request"
    :class="{ 'ltcs-missing-request--compact': compact }"
  >
    <p v-if="message" class="ltcs-missing-request__msg">{{ message }}</p>
    <button type="button" class="ltcs-missing-request__btn" @click="showModal = true">
      <v-icon size="14">mdi-cloud-download-outline</v-icon>
      {{ buttonLabel }}
    </button>
    <LtcsHrRequestModal
      v-model="showModal"
      :member-code="memberCode"
      :biz-gubun="bizGubun"
      :year-month="yearMonth"
      :allowed-types="types"
      @updated="emit('updated')"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import LtcsHrRequestModal from '@/components/member/request/LtcsHrRequestModal.vue';
import { isLtcsMacroBizGubun } from '@/constants/ltcsMacro';

const props = withDefaults(
  defineProps<{
    memberCode: string | number;
    bizGubun?: string;
    yearMonth: string;
    types: readonly string[];
    message?: string;
    buttonLabel?: string;
    compact?: boolean;
  }>(),
  {
    bizGubun: '',
    message: '',
    buttonLabel: '롱텀케어에서 가져오기',
    compact: false,
  }
);

const emit = defineEmits<{
  (e: 'updated'): void;
}>();

const showModal = ref(false);

const memberCode = computed(() => String(props.memberCode || ''));

const canRequest = computed(
  () => !!memberCode.value && isLtcsMacroBizGubun(props.bizGubun)
);
</script>
